import { AuthService } from './../../services/auth.service';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { ExpedientesService } from './../../services/expedientes.service';
import { MensajesService } from './../../services/mensajes.service';
import { ClientesService } from './../../services/clientes.service';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styles: [`
    .ng-invalid.ng-dirty:not(form){
      border:1px solid red;
    }
    .ng-submitted .ng-invalid:not(form){
      border:1px solid red;
    }
  `]
})
export class ClienteComponent implements OnInit {
  
  @ViewChild("mensajeCliente") mensajeCliente: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;
  cliente={};
  direcciones=[];
  expedientes=[];
  ref="";
  mensajesRecibidos;
  mensajesEnviados;
  activo:boolean=false;
  gestoria:boolean=false;
  sectores=[
    "Administración",
    "Agricultura, ganadería y pesca",
    "Arquitectura",
    "Construcción",
    "Diseño Gráfico",
    "Educación",
    "Finanzas",
    "Industria",
    "Informática",
    "Ingeniería",
    "Ocio",
    "Organismos oficiales",
    "Telecomunicaciones",
    "Transporte",
    "Otros"
  ];

  ordenacion={};

  currentPass:string;
  nextPass:string;
  nextPass2:string;

  paginaActualRecibidos:number=1;
  paginaSiguienteRecibidos:number;
  paginaAnteriorRecibidos:number;
  totalPaginasRecibidos:number;
  paginaActualEnviados:number=1;
  paginaSiguienteEnviados:number;
  paginaAnteriorEnviados:number;
  totalPaginasEnviados:number;
  paginaActualExpedientes:number=1;
  paginaSiguienteExpedientes:number;
  paginaAnteriorExpedientes:number;
  totalPaginasExpedientes:number;

  constructor(public _clientesService:ClientesService,public mensajesService:MensajesService,
    public expedientesService:ExpedientesService, public route:ActivatedRoute, public router:Router,
    private renderer:Renderer2, private location:Location, private auth:AuthService) {
      this.cliente={
        CLcif:""
      };
      this.mensajesEnviados=[];
      this.mensajesRecibidos=[];
      this.route.params.subscribe(params=>{
      
      this.ref=params.ref;
      if(this.ref!="nuevo"){
        this.cargarCliente();
      }
    });
  }

  ngOnInit() {
    this.ordenacion['campo']="MEfecha";
    this.ordenacion['orden']="DESC";
  }

  guardarCliente(myform:NgForm) {
    
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
      this.activo==true?this.cliente["CLactivo"]=1:this.cliente["CLactivo"]=0;
      this.gestoria==true?this.cliente["CLgestoria"]=1:this.cliente["CLgestoria"]=0;
      
      if(this.ref=="nuevo"){
          this._clientesService.insertCliente(this.cliente).subscribe(response=>{
            
            let texto=this.renderer.createText(response["mensaje"]);
            if(response["err"]==false){
              this.renderer.setStyle(this.mensajeCliente.nativeElement,"color", "green");
              this.renderer.appendChild(this.mensajeCliente.nativeElement,texto);
              setTimeout(() => {
                this.renderer.removeChild(this.mensajeCliente.nativeElement,texto);
                this.location.back();
              }, 2000);
            }else{
              this.renderer.setStyle(this.mensajeCliente.nativeElement,"color", "red");
              this.renderer.appendChild(this.mensajeCliente.nativeElement,texto);
              setTimeout(() => {
                this.renderer.removeChild(this.mensajeCliente.nativeElement,texto);
              }, 2000);
            }
          
          }, err=>console.log(err));
        }else{
          this._clientesService.updateCliente(this.cliente , this.ref).subscribe(response=>{
            
            let texto=this.renderer.createText(response["mensaje"]);
            if(response["err"]==false){
              this.renderer.addClass(this.mensajeCliente.nativeElement, "text-success");
            }else{
              this.renderer.addClass(this.mensajeCliente.nativeElement, "text-danger");
            }
            this.renderer.appendChild(this.mensajeCliente.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajeCliente.nativeElement,texto);
            }, 2000);
          
          });
        }
        
  }

  

  cargarCliente(){
    let id=Number(this.ref);
    this._clientesService.getCliente(id).subscribe(resp=>{
      
      this.cliente=resp;
      
      this.cliente["CLactivo"]==1?this.activo=true:this.activo=false;
      this.cliente["CLgestoria"]==1?this.gestoria=true:this.gestoria=false;
      this.cargarMensajesRecibidos(this.paginaActualRecibidos);
      this.cargarMensajesEnviados(this.paginaActualEnviados);
      this.cargarDirecciones();
      this.cargarExpedientes(this.paginaActualExpedientes);
    });
  }


  cargarDirecciones(){
    this._clientesService.getDirecciones(this.ref).subscribe(resp=>{
      this.direcciones=resp;
      return true;
    });
  }

  cargarMensajesEnviados(pagina){
    this.mensajesService.getMensajesEnviados(this.cliente, pagina, this.ordenacion).subscribe(resp=>{
      this.mensajesEnviados=resp["mensajes"];
      this.paginaActualEnviados=parseInt(resp["pagina"]);
      this.paginaAnteriorEnviados=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteEnviados=parseInt(resp["pag_siguiente"]);
      this.totalPaginasEnviados=parseInt(resp["total_paginas"]);
    });
  }
  
  cargarMensajesRecibidos(pagina){
    this.mensajesService.getMensajesRecibidos(this.cliente, pagina, this.ordenacion).subscribe(resp=>{
      this.mensajesRecibidos=resp["mensajes"];
      this.paginaActualRecibidos=parseInt(resp["pagina"]);
      this.paginaAnteriorRecibidos=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteRecibidos=parseInt(resp["pag_siguiente"]);
      this.totalPaginasRecibidos=parseInt(resp["total_paginas"]);
    });
  }

  previousPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaAnteriorRecibidos);
  }

  previousPageEnviados(){
    this.cargarMensajesEnviados(this.paginaAnteriorEnviados);
  }

  previousPageExpedientes(){
    this.cargarMensajesEnviados(this.paginaAnteriorExpedientes);
  }


  nextPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaSiguienteRecibidos);
  }

  nextPageEnviados(){
    this.cargarMensajesEnviados(this.paginaSiguienteEnviados);
  }

  nextPageExpedientes(){
    this.cargarExpedientes(this.paginaSiguienteExpedientes);
  }


  cargarExpedientes(pagina){
    this.expedientesService.getExpedientesCliente(this.cliente, pagina)
    .subscribe(resp=>{
      this.expedientes=resp["expedientes"];
      this.paginaActualExpedientes=parseInt(resp["pagina"]);
      this.paginaAnteriorExpedientes=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteExpedientes=parseInt(resp["pag_siguiente"]);
      this.totalPaginasExpedientes=parseInt(resp["total_paginas"]);
      return true;
    })
  }

  reiniciarCliente(){
    if(this.ref!='nuevo'){
      this.cargarCliente();
    }else{
      
    }
  }

  eliminarMensajeRecibido(codigo){
    this.mensajesService.eliminarMensajeRecibidoCliente(codigo)
    .subscribe(resp=>{
      this.cargarMensajesRecibidos(this.paginaActualRecibidos);
    });
  }

  eliminarMensajeEnviado(codigo){
    this.mensajesService.eliminarMensajeEnviadoCliente(codigo)
    .subscribe(resp=>{
      this.cargarMensajesEnviados(this.paginaActualEnviados);
    });
  }

  existeCliente(){
    let devolver:boolean=false;
    for(let j=0;j<this._clientesService.clientes.length;j++){
      if(this.ref==this._clientesService.clientes[j].CLcodigo){
        
        devolver=true;
      }
    }
    return devolver;
  }

  eliminarExpediente(codExpediente){
    let respuesta=prompt('Si desea borrar este expediente, escriba "borrar" en el campo de texto.');
    if(respuesta==="borrar"){
      this.expedientesService.borrarExpediente(codExpediente)
      .subscribe(resp=>{
        alert(resp["mensaje"]);
        if(resp["err"]==false){
          this.cargarExpedientes(this.paginaActualExpedientes);
        }
      });
    }else{
      alert("Expediente no borrado.");
    }
  }

  volver(){
    this.location.back();
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }
    
    this.cargarMensajesEnviados(this.paginaActualEnviados);
    this.cargarMensajesRecibidos(this.paginaActualRecibidos);
    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cliente/cliente.component.ts